export default String.raw`
.comparison {
    width: 100%;
    margin: 0 auto;

    &__wrapper {
        padding: 0 9%;
        overflow-x: hidden;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        padding-bottom: 20px;

        &-title {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            color: $primaryColorFont;
        }

        &-count {
            @include subtitle-regular;
            color: #767676;
        }

        &-clear-all {
            margin-left: auto;
        }
    }

    .swiper {
        overflow: unset !important;
    }

    .swiper-slide {
        height: auto !important;
    }

    .gradient {
        position: absolute;
        z-index: 1;
        top: 0;
        right: -25%;
        width: 25%;
        height: 100%;
        pointer-events: none;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), rgb(255, 255, 255));
    }

    // Table
    .table {
        &__section {
            width: 100%;
            display: flex;
            flex-direction: column;
            position: relative;
        }

        &__row {
            display: flex;
            @include body-2-regular;

            &-cell {
                display: flex;
                flex: 1 0 $table-column-width;
                flex-wrap: nowrap;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                padding: $table-cell-height $table-cell-width;
                border-right: 1px solid #f3f3f3;
                border-bottom: 1px solid #f3f3f3;
                text-align: center;
            }

            &-cell-value {
                display: flex;
                align-content: stretch;
                justify-content: center;
                align-items: center;
                flex-wrap: nowrap;
                overflow-wrap: anywhere;
                @include body-2-regular;
            }

            &-cells::-webkit-scrollbar {
                display: none;
            }

            .full-row {
                background: #F8F9FA !important;
                border-right: none !important;
                align-items: flex-start !important;
            }
        }

        &__header {
            position: sticky;
            @include body-2-medium;
        }
    }
}

// Comparer
.comparer {
    position: relative;
    width: 100%;
    border-collapse: collapse;

    &__table {
        clip-path: inset(-100vw -100vw -100vw 1px);
        margin-bottom: 32px;

        &-more {
            flex-direction: column;
            width: 100%;
            height: 100%;
            gap: 16px;

            .button__text {
                text-align: center;
            }

            &-title {
                @include subtitle-medium;
                text-align: center;
            }
        }

        &-attribute-name {
            align-items: flex-start;
            background: white;
            z-index: 2;
            padding: $table-cell-height $table-first-column-left;
            flex: 1 0 20% !important;
        }

        .top-info .table__row-cell {
            border-right: none;
        }
    }

    &__sticky-header {
        position: fixed;
        width: 100%;
        top: 0;
        right: 0;
        left: 0;
        background: #ffffff;
        box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 4px 0px, rgba(0, 0, 0, 0.08) 0px 0px 2px 1px;
        z-index: 1000; 
        padding: 0 9%;

        .table__section {
            clip-path: inset(-100vw -100vw -100vw 1px);
        }
    }

    &__slider,
    &__slider-main {
        display: flex;
        flex: 1 0 calc(3 * $table-column-width);
    }

    &__slider-button-next,
    &__slider-button-prev {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        z-index: 1000;
    }

    &__slider-button-next {
        right: -24px;
    }

    &__slider-button-prev {
        left: calc((45% / 2) - 24px);
    }
}

.property__rating {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;

    svg {
        fill: #F5A623;
    }

    &-count {
        @include body-2-regular;
    }
}

.product-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 8px;
    margin: 0 auto;
    background-color: #ffffff;
    overflow: hidden;

    &__image {
        position: relative;
        display: flex;
        max-width: 210px;
        justify-content: center;
        align-items: center;

        &-wrapper {
            position: relative;
            display: flex;
            height: 210px;
            justify-content: center;
        }

        img {
            max-width: 100%;
            max-height: 100%;
            border-radius: 4px;
            aspect-ratio: 1 / 1;
            object-fit: contain;
        }
    }

    &__remove {
        display: flex;
        position: absolute;
        width: 16px;
        height: 16px;
        top: 5%;
        right: 5%;
        border: none;
        background-color: transparent;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        padding: 0;

        svg {
            fill: #959595;
        }
    }

    &__info {
        display: flex;
        width: 100%;
        flex-direction: column;
        gap: 16px;
        flex: 1;

        &-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    }

    &__name {
        flex: 1 0 auto;
        color: $primaryColorFont;
        @include body-1-regular;
        text-decoration: none;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    &__prices {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }

    &__price {
        &-current {
            @include body-1-semi-bold;
        }

        &-previous {
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;
            color: #767676;
        }

        &-tax {
            @include body-1-regular;
        }

        &-lowest {
            @include body-3-medium;
            color: #767676;
        }
    }

    &__buttons {
        display: flex;
        margin-top: auto;
        width: 100%;
        justify-content: space-between;
    }

    &.collapsed {
        gap: 8px;
        flex-direction: row;

        .product-card {
            &__image {
                flex: 1;
                max-width: 65px;
            }

            &__info {
                flex: 3;
                gap: 0;
                justify-content: space-between;
            }

            &__name {
                @include body-2-regular;
                height: 2lh;
            }

            &__price-current {
                @include body-1-medium;
            }
        }
    }
}

.label {
    margin-bottom: auto;
    flex-grow: 1;
    display: flex;
    gap: 8px;
    align-items: center;

    &__icon {
        display: flex;
        width: 24px;
        height: 24px;
        justify-content: center;
        align-items: center;
    }

    &.sign-in {
        @include body-2-regular;
    }
}

//Exception:

.button[aria-label="notify-about-availability"] .button__text {
    max-width: 10ch;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
`